import BlogItem from '../models/blogItem';

const SKILL_ITEMS = [

    new BlogItem(
        1,
        "#1. Do better, Remote Condition Monitoring",
        "February 2025",
        "../img/blog/rcm/railmon.png",
        "What if that really important system could let you know when things start going wrong. I'm talking about the subtle, early, and hard for humans to detect tell-tale signs that failure will occur in the not too distant future.",
        "I'd imagine you could plan restorative tasks to correct whatever is ailing the system. Making yourself look pretty good in the process.",
        "I've been involved in my fair share of critical system failures. Nobody looks good, sure there is a level of relief and gratitude from the boss when you save the day but they're thinking it should not be this way and if you're honest with yourself, you know as an engineer, you can do more to stop critical failures.",
        "I'm going to use a railway points machine in this example but the same discussion points can be applied to any system! A railway points machine is a safety critical mechanical/electrical device, it has two main functions: to mechanically lock a converging or diverging railway junction, and  to inform the signalling interlocking of its state so that the signal the train diverts is looking at is showing a stop or proceed aspect.",
        "A points machine is a series machine. This means a sequence of signals and events occur which results in the switch rail moving from a Normal to Reverse or visa-versa positions and locking. This movement can be timed based on when detection is lost and regained in either direction. This is significant because as this movement time changes a monitoring system can plot the deterioration of the performance between restoration tasks. Standard deviation can be used to determine how far the current movements are deviating from the average. With this data you can determine at what point a restoration task should be performed.",
        "So I've  taken it upon myself to develop this system. In my GitHub Repo you can find the following applications: LogReplay, Data Acquisition System, Common-Database, and RailMon. The LogReplay app simply reproduces the signalling systems log files indicating when specific relays are switching from off to on and on to off. The Data Acquisition System reads these log files looking for specific configured paired relays changing state and calculating the time in milliseconds indicating the points machine movement. This information is then sent to the common-database for further calculations and storage. Finally RailMon visualises the data (this can be seen in the image above).",
        null,
        "There are commercial solutions out there but they are expensive. This is a simple system any railway can implement with a little know how in a spreadsheet!!",
        "I'd love to hear from you if you have implemented anything similar or if you want to understand a little more of the know-how, or if you simply disagree.",
        null,
        true,
        true
    ),
    new BlogItem(
        0,
        "Headline",
        "February 2025",
        null,
        "Introduction",
        "Lead in",
        "Para 1",
        "Para 2",
        "Para 3",
        "Para 4",
        "Para 5",
        "Conclusion",
        "Let me know if you wan't to discuss any part of this",
        "references",
        false,
        false
    )
]

export default SKILL_ITEMS;